import React, {useState} from "react";
import Field from "../Field.tsx";
import {deleteUser} from "../../services/userService.ts";
import useAuthStore from "../../store/useAuthStore.ts";
import {Spacer} from "@chakra-ui/react";

const MAX_ATTEMPTS = 3; // Maximum number of attempts allowed

const DeleteAccount: React.FC = () => {
  const {logout} = useAuthStore()
  const [password, setPassword] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [numberOfAttempts, setNumberOfAttempts] = useState<number>(0);
  const [error, setError] = useState<boolean>(false);

  const handleSubmit: (e: React.FormEvent) => void = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true)
    deleteUser(password).then((isApprove: boolean) => {
      setNumberOfAttempts(prev => prev + 1);
      if (isApprove) {
        logout()
      } else {
        setError(true)
      }
      setIsLoading(false)
    })
  }

  return (
    <form className="" action="" onSubmit={handleSubmit}>
      <div className="mb-8 h4">We’re sorry to see you go</div>
      <div className="mb-6 caption1 text-n-400">
        Warning: Deleting your account will permanently remove all of
        your data and cannot be undone. This includes your profile,
        chats, comments, and any other information associated with your
        account. Are you sure you want to proceed with deleting your
        account?
      </div>
        <Field
          className="mb-6"
          label={`Your password | (${MAX_ATTEMPTS - numberOfAttempts} attempt${MAX_ATTEMPTS - numberOfAttempts === 1 ? '' : 's'} remaining)`}
          placeholder="Password"
          type="password"
          icon="lock"
          value={password}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setPassword(e.target.value)}
          required
        />
      {error && <div className="mb-4 text-red-500">Incorrect password. Please try again.</div>}
      {numberOfAttempts >= MAX_ATTEMPTS && (
        <div className="mb-4 text-red-500">
          You have exceeded the maximum number of attempts. Please try again later.
        </div>
      )}
      <button className="btn-red w-full" disabled={isLoading || !password || numberOfAttempts >= MAX_ATTEMPTS}>
        Delete account
      </button>
    </form>
  );
};

export default DeleteAccount;
